import { BaseButton } from "../../../../components/Button/BaseButton.tsx";
import { ThumbnailContent } from "../../../../components/Content/ThumbnailContent.tsx";
import { PimentoStar } from "../../../../components/Icon/assets/PimentoStar.tsx";
import { IMAGE_RESOURCE_TYPE } from "../../../Board/constants.ts";
import { DEFAULT_STYLE_MODELS_PROPERTIES } from "../../../constants.ts";
import { useUser } from "../../../hooks/useUser.ts";
import type { ModelWithIsCompatibleAndTags } from "../../../types.ts";
import { isUserAllowedTo } from "../../../utils/isUserAllowedTo.ts";
import { useUserCanDeleteModel } from "../hooks/useUserCanDeleteModel.ts";
import { useUserCanOpenModelTagMenu } from "../hooks/useUserCanOpenModelTagMenu.ts";
import { useUserCanRenameModel } from "../hooks/useUserCanRenameModel.ts";
import { ModelExtraMenu } from "./ModelExtraMenu.tsx";

export const ModelTile = ({
  model,
  onClick,
  isLoading,
  disabled,
}: {
  model: ModelWithIsCompatibleAndTags;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  const { user } = useUser();
  const userCanOpenModelTagMenu = useUserCanOpenModelTagMenu();
  const userCanDeleteModel = useUserCanDeleteModel(model);
  const userCanRenameModel = useUserCanRenameModel(model);

  const thumbnailUrl =
    model.thumbnail_url ??
    DEFAULT_STYLE_MODELS_PROPERTIES[model.uuid]?.thumbnail_url;

  return (
    <div className="group relative flex-col-center">
      <BaseButton
        className="w-full"
        style={{ height: 220 }}
        onClick={onClick}
        loading={isLoading}
        disabled={disabled}
      >
        <div className="relative group w-full h-full rounded-100 overflow-clip">
          {thumbnailUrl ? (
            <ThumbnailContent
              resourceType={IMAGE_RESOURCE_TYPE}
              src={thumbnailUrl}
              className="h-full w-full group-hover:scale-110"
            />
          ) : (
            <div className="flex-col-center h-full w-full bg-surface-emphasis-primary-rest group-hover:scale-110">
              <PimentoStar size={70} className="fill-button-primary-rest" />
            </div>
          )}
          {["CREATED", "TRAINING"].includes(model.status) ? (
            <div className="absolute left-0 top-0 w-full h-full bg-[rgb(200,200,200,0.85)] text-white flex-row-center label-lg-semibold">
              {model.status === "CREATED" ? "Draft" : "Training"}
            </div>
          ) : null}
          <div className="absolute left-0 bottom-0 rounded-b-100 w-full h-full bg-gradient-to-t from-[#494949]/80 to-80%" />
        </div>
      </BaseButton>
      <div className="absolute bottom-200 w-[90%] truncate body-lg-semibold text-white">
        {model.name ?? "Untitled"}
      </div>
      {user &&
        (userCanDeleteModel ||
          userCanRenameModel ||
          isUserAllowedTo(user, "references:curate") ||
          userCanOpenModelTagMenu) && (
          <div className="absolute right-100 top-100">
            <ModelExtraMenu
              model={model}
              className="invisible group-hover:visible"
            />
          </div>
        )}
    </div>
  );
};
